module.exports = __webpack_public_path__ + "img/fitted-mask-elastic-hero.870d5f7a.jpg";